import { createContext, useContext, ReactNode } from 'react';

interface RefreshContextType {
  isRefreshing: boolean;
}

const RefreshContext = createContext<RefreshContextType>({ isRefreshing: false });

export function RefreshProvider({ 
  children, 
  isRefreshing 
}: { 
  children: ReactNode; 
  isRefreshing: boolean;
}) {
  return (
    <RefreshContext.Provider value={{ isRefreshing }}>
      {children}
    </RefreshContext.Provider>
  );
}

export function useRefreshState() {
  return useContext(RefreshContext);
}
